<script type="ts">
    import { Modal } from "carbon-components-svelte";
    import { stores } from "@nubolab-ffwd/svelte-fluent/src/internal/FluentProvider.svelte";
	import { Localized } from '@nubolab-ffwd/svelte-fluent';

	const { getTranslation } = stores();

    export let showHelp;
    export let firstProject;

</script>

<Modal
    size="xs"
    bind:open={showHelp}
    modalHeading={$getTranslation("help-title").value}
    primaryButtonText={firstProject ? $getTranslation("help-ok-first").value : $getTranslation("help-ok").value}
    on:open
    on:close
    on:submit
>
    <div class="modal-content-wrapper modal-text">
        <p><Localized id="help-p1" /></p>
        <p><Localized id="help-p2" /></p>
        <p><Localized id="help-p3" /></p>
        <ul>
            <li><Localized id="help-l1" /></li>
            <li><Localized id="help-l2" /></li>
            <li><Localized id="help-l3" /></li>
            <li><Localized id="help-l4" /></li>
            <li><Localized id="help-l5" /></li>
        </ul>
    </div>
</Modal>